module.exports = __webpack_public_path__ + "img/banner_hk.7fc40478.jpg";